import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { CheckIcon, Icon } from 'components/shared/Icon/Icon'
import { List } from 'components/shared/List/List'

import styles from './Languages.module.scss'

export const Languages = ({ activeLanguage, languages, onSwitchLanguage }) => (
  <Dropdown.MenuItem className={styles.languages}>
    <span className={styles.label}>{t`Languages`}</span>
    <List className={styles.list} direction="column">
      {R.map(
        ({ icon, original, value }) => (
          <List.Item key={value}>
            <Dropdown.Action
              className={styles.action}
              onClick={() => onSwitchLanguage({ code: value })}
            >
              <img className={styles.flag} src={icon} alt={value} />
              <span className={styles.name}>{original}</span>
              {R.equals(activeLanguage, value) ? (
                <Icon className={styles.icon} icon={CheckIcon} size={20} />
              ) : null}
            </Dropdown.Action>
          </List.Item>
        ),
        languages,
      )}
    </List>
  </Dropdown.MenuItem>
)
